<template>
  <div>
    <!-- Link for documentation -->
    <!-- https://docs.dropzone.dev/configuration/basics/configuration-options -->
    <!-- https://rowanwins.github.io/vue-dropzone/docs/dist/#/installation -->
    <vue2-dropzone
      id="file-uploader"
      ref="uploader"
      :duplicateCheck="true"
      :useCustomSlot="true"
      :options="uploadOptions"
      :destroyDropzone="false"
      @vdropzone-drag-over="dragover = true"
      @vdropzone-drag-leave="dragover = false"
      @vdropzone-removed-file="removeFile"
      @vdropzone-upload-progress="fileProgress"
      @vdropzone-sending="sending"
      @vdropzone-file-added-manually="fileAddedManually"
      @vdropzone-drop="drop"
      @vdropzone-file-added="fileAdded"
      @vdropzone-complete="complete"
      @vdropzone-success="success"
      @vdropzone-error="error"
      class="upload-container"
      :class="{
        pointerEventAuto: !disableUpload,
        pointerEventNone: disableUpload,
        uploadBorder: uploadBorder
      }"
    >
      <div v-if="!dragover" class="w-100">
        <b-row align-h="between" align-v="center">
          <b-col md="7" lg="8">
            <div class="upload-inner-container mb-3 mb-lg-0">
              <div class="upload-title">
                {{ title }}
                <span v-if="isOptional">(Optional)</span>
              </div>
              <div class="upload-subtext">
                {{ subtext }}
              </div>
            </div>
          </b-col>
          <b-col md="5" lg="4" xl="4">
            <action-button
              v-if="!disableUpload"
              variant="outline"
              class="ml-auto px-3"
            >
              <img
                src="@/assets/images/common/upload-icon.svg"
                alt="upload"
                width="14"
                class="mr-2"
              />
              {{
                !multiple.includes(docTag)
                  ? $t('invoices.add.helpers.uploadFile')
                  : $t('invoices.add.helpers.uploadFiles')
              }}
            </action-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12">
            <slot name="body"></slot>
          </b-col>
        </b-row>
      </div>
      <div
        class="uploader-hover d-flex justify-content-center align-items-center"
        v-else
      >
        {{ $t('invoices.add.helpers.dropFileHere') }}
      </div>
    </vue2-dropzone>
    <div class="error-message" v-if="errorMessage">
      <b-icon-x-circle scale="1.2" class="mx-2 mr-3" />
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import Vue2Dropzone from 'vue2-dropzone'
import ActionButton from '@/components/common/ActionButton'
import { DOC_TAG } from '@/utils/constants'
import { uploadFilesBus } from '../../main'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  components: {
    Vue2Dropzone,
    ActionButton
  },
  props: [
    'index',
    'title',
    'subtext',
    'itemKey',
    'docTag',
    'uploadsSaved',
    'isOptional',
    'documentId',
    'uploadBorder',
    'acceptedFiles',
    'multiple',
    'apiUrl',
    'callback',
    'maxFilesize'
  ],
  data() {
    return {
      task: {
        id: '1'
      },
      dragover: false,
      uploading: false,
      errorMessage: ''
    }
  },
  created() {
    uploadFilesBus.$on('resetUploads', this.resetUploads)
  },
  mounted() {
    if (
      this.uploadsSaved &&
      this.uploadsSaved[this.index][this.docTag] &&
      this.uploadsSaved[this.index][this.docTag].length
    ) {
      this.$refs.uploader.removeAllFiles()
      this.uploadsSaved[this.index][this.docTag].forEach((inv, index) => {
        const file = {
          docId: inv.docId, // document id
          id: inv.id, // task id
          size: 123124,
          name: inv.name || `Document ${index + 1}`,
          type: 'application/pdf',
          url: inv.url
        }
        this.$refs.uploader.manuallyAddFile(file, inv.url)
      })
    }
  },
  methods: {
    resetUploads() {
      this.$refs.uploader && this.$refs.uploader.removeAllFiles()
    },
    fileAddedManually(file) {
      file.previewTemplate
        ?.querySelector('a.download-link')
        ?.setAttribute('href', file.url || '/')
    },
    fileProgress(file, progress) {
      this.uploading = progress > 0 && progress < 100
    },
    removeFile(file, error, xhr) {
      const id = (file.upload && file.upload.docId) || file.docId
      if (this.callback) {
        uploadFilesBus.$emit(
          'removeDocument',
          this.index,
          this.docTag,
          id,
          this.callback
        )
      } else {
        uploadFilesBus.$emit('removeDocument', this.index, this.docTag, id)
      }
      this.dragover = false
      this.uploading = false
    },
    success(file, response) {
      this.errorMessage = ''
      file.upload.docId = response.id
      const documentData = {
        docTag: this.docTag,
        id: response.id,
        url: response.url,
        tag: response.tag,
        name: file.upload.filename
      }
      file.previewTemplate
        ?.querySelector('a.download-link')
        ?.setAttribute('href', documentData.url || '/')
      this.$mpTrack('File Document uploaded', {
        documentType: this.docTag,
        name: file && file.upload && file.upload.filename
      })
      uploadFilesBus.$emit('addDocument', documentData, this.callback)
    },
    fileAdded() {},
    complete() {},
    error(file, err) {
      const id = (file.upload && file.upload.docId) || file.docId

      const errMsg = err.error && err.error.message
      this.errorMessage = errMsg || err
      if (
        this.errorMessage &&
        this.errorMessage.includes('Server responded with 0 code')
      ) {
        this.errorMessage = 'Failed to upload document'
      }
      this.$refs.uploader.removeFile(file)
      uploadFilesBus.$emit('removeDocument', this.index, this.docTag, id)
      this.dragover = false
      if (err) {
        this.$mpTrack(
          'Add Bank - Validation errors triggered on any file upload',
          {
            error: err
          }
        )
      }
    },
    sending(file, xhr, formData) {
      if (this.itemKey) {
        formData.append('tag', DOC_TAG[this.itemKey] || this.itemKey)
      } else {
        formData.append('tag', DOC_TAG[this.docTag])
      }
    },
    drop() {
      this.dragover = false
    }
  },
  computed: {
    countFiles() {
      return {
        len: this.uploadsSaved[0][this.docTag].length,
        tag: this.docTag,
        multi: this.multiple,
        uploadsSaved: this.uploadsSaved
      }
    },
    disableUpload() {
      if (!this.multiple.includes(this.docTag)) {
        return (
          this.uploadsSaved[0][this.docTag] &&
          this.uploadsSaved[0][this.docTag].length >= 1
        )
      }
      return false
    },
    uploadOptions() {
      // reference - https://github.com/dropzone/dropzone/blob/main/src/options.js
      return {
        previewTemplate: `
        <div class="file-upload-preview mt-2">
          <div class="file-upload-progress-container">
            <span class="file-upload-progress" data-dz-uploadprogress></span>
          </div>
          <div class="file-upload-preview-inner p-0">
            <div class="file-upload-details d-flex justify-content-between w-100">
              <div class="content text-left">
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none" class="mr-2">
                  <path d="M7.69353 2L9.58963 4H17.9609V14H2.7921V2H7.69353ZM8.48041 0H2.7921C1.74924 0 0.905477 0.9 0.905477 2L0.895996 14C0.895996 15.1 1.74924 16 2.7921 16H17.9609C19.0038 16 19.857 15.1 19.857 14V4C19.857 2.9 19.0038 2 17.9609 2H10.3765L8.48041 0Z" fill="#0A2E57"/>
                </svg>
                <div class="dz-filename" data-dz-name></div>
              </div>
              <div class="download">
                <a class="download-link dz-link" data-dz-download target="_blank">
                  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" class="mr-2">
                    <path d="M14 6H10V0H4V6H0L7 13L14 6ZM6 8V2H8V8H9.17L7 10.17L4.83 8H6ZM0 15H14V17H0V15Z" fill="#26B67F"/>
                  </svg>Download
                </a>
              </div>
              <div class="remove">
                <span class="remove-link dz-link" data-dz-remove >
                  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" class="mr-2">
                    <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#26B67F"/>
                  </svg>Remove
                </span>
              </div>
            </div>
          </div>
        </div>`,
        url: this.apiUrl,
        method: 'post',
        maxFiles: this.multiple.includes(this.docTag) ? 20 : 1,
        maxFilesize: this.maxFilesize ? this.maxFilesize : 50, // 50 MB
        dictFileTooBig: `File size exceeded maximum limit of ${
          this.maxFilesize ? this.maxFilesize : '50'
        } MB. Please try again.`,
        dictMaxFilesExceeded: 'Maximum number of files reached.',
        dictInvalidFileType: 'Please upload the correct type of file.',
        timeout: 120000, // 120 seconds
        headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        acceptedFiles: this.acceptedFiles || '',
        destroyDropzone: false,
        renameFile: (file) => {
          return file.name.split(' ').join('_')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pointerEventNone {
  pointer-events: none;
}
.pointerEventAuto {
  pointer-events: auto;
}
.error-message {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #cc6340;
  padding: 4px 28px;
  padding-bottom: 16px;
}
.upload-container {
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  background: $white;
  border: 0px;
  &.uploadBorder {
    border: 1px solid $sky-blue-400;
  }
  border-radius: 8px;
  .upload-inner-container {
    .upload-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 100%;
      color: $noble-blue-500;
      margin-bottom: 8px;
      span {
        font-size: 16px;
      }
    }
    .upload-subtext {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: $black;
      margin-bottom: 4px;
    }
    .upload-note {
      display: none;
      font-style: italic;
      font-weight: 400;
      font-size: 10px;
      line-height: 10px;
      color: $neutral-gray-500;
    }
  }
}
</style>
<style lang="scss">
.vue-dropzone {
  font-family: $nunito;
  padding: 0;
  border-radius: 5px;
  // box-shadow: 0 2px 5px 0 rgba(black, 0.05);
  border: solid 1px $dc-form-border-color;
  background-color: $white;
  transition: all 0.2s;
  cursor: pointer;
  min-height: initial;
  .dz-message {
    display: block !important;
    margin: 0;
    text-align: left;
    .upload-placeholder-title {
      font-family: $nunito;
      font-size: 1rem;
      font-weight: 500;
      color: $secondary;
      margin: 0;
    }
    .upload-desc,
    .upload-size {
      font-family: $nunito;
      font-size: 0.67rem;
      line-height: 1.5;
      color: $dc-label-color;
      margin: 0;
    }
    .svg {
      background: $light-background-color;
      height: 35px;
      width: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: $dc-svg;
      margin: 0 1rem;
      transition: all 0.2s;

      &.attachment {
        transform: rotate(270deg);
      }

      span {
        font-size: 1.47rem;
        margin-top: -5px;
      }
    }
    .uploader-hover {
      padding: 1rem 0;
      font-family: $nunito;
      font-size: 1rem;
      font-weight: 500;
      color: $dc-upload;
    }
  }
  &.dz-drag-hover {
    border: 2px dashed $dc-upload;
  }
  &:hover {
    .upload-placeholder-title {
      color: black;
    }
    .upload-desc {
      color: $dc-label-color;
    }
    .svg {
      background: $secondary;
      color: $white;
    }
  }
  .file-upload-preview {
    flex-grow: 1;
    position: relative;
    &.dz-success,
    &.dz-error {
      .file-upload-progress-container {
        opacity: 0;
      }
    }

    .file-upload-details {
      flex-wrap: wrap;
      width: 100%;
      .messages {
        padding: 8px 0;
        display: flex;
        img {
          width: 100%;
          height: 100%;
        }
        .alert {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
      .content {
        padding: 8px 0;
        display: flex;
        flex-grow: 1;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .dz-filename {
          display: inline;
          text-overflow: ellipsis;
          white-space: pre;
          overflow: hidden;
          width: 200px;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: $secondary;
          margin-right: 8px;
        }
      }
      .download {
        padding: 8px;
        pointer-events: auto;
        display: flex;
        width: auto;
        margin-right: 8px;
        .dz-link {
          cursor: pointer;
          width: max-content;
          color: $wealthy-green-500;
        }
      }
      .remove {
        padding: 8px;
        pointer-events: auto;
        display: flex;
        width: auto;
        margin-right: 8px;
        align-items: center;
        .dz-link {
          cursor: pointer;
          width: max-content;
          color: $wealthy-green-500;
        }
      }
    }
    .file-upload-progress-container {
      width: 100%;
      height: 10%;
      left: 0;
      top: auto;
      bottom: 0;
      position: absolute;
      right: 0;
      margin-left: 0;
      border-radius: 0;
      margin-top: 0;
      transition: all 0.2s linear;
      .file-upload-progress {
        background: $primary;
        transition: all 0.2s linear;
        width: 0;
        display: block;
        height: 100%;
      }
    }
  }
  &.dz-started {
    display: block !important;
    .dz-processing {
      background: $white;
    }
    .dz-complete {
      background: $white;
    }
  }
  .dz-success-mark,
  .dz-error-mark {
    display: none;
    width: 16px;
    img {
      width: 100%;
      height: auto;
    }
  }

  .dz-success {
    .dz-success-mark {
      display: block;
    }
  }

  .dz-error {
    .dz-error-mark {
      display: block;
    }
  }
}
.vue-dropzone .file-upload-preview.dz-success .file-upload-progress-container,
.vue-dropzone .file-upload-preview.dz-error .file-upload-progress-container {
  height: 0px;
}
</style>
